import { render, staticRenderFns } from "./ConsentPage.vue?vue&type=template&id=673c68eb"
import script from "./ConsentPage.vue?vue&type=script&lang=js"
export * from "./ConsentPage.vue?vue&type=script&lang=js"
import style0 from "./ConsentPage.vue?vue&type=style&index=0&id=673c68eb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports